import { useFormik } from 'formik';
import * as Yup from 'yup';

import { refuseReasonsOptions } from 'commons';
import { Button, Select } from 'components';
import { formValidations } from 'helpers';

interface Props {
  onBack: () => void;
  onRefuse: (reason: string) => void;
}

export function RefusalReasonSelect({ onBack, onRefuse }: Props) {
  const revokeValidation = Yup.object().shape({
    reason: Yup.string().required('Motivo'),
  });

  const formRefuse = useFormik({
    initialValues: {
      reason: '',
    },
    validateOnChange: false,
    validationSchema: revokeValidation,
    validate: values => {
      formValidations.validationSchema({ schema: revokeValidation, values });
    },
    onSubmit: async values => {
      onRefuse(values.reason);
    },
  });

  const { values, errors, handleChange } = formRefuse;

  return (
    <>
      <div>
        <p className="py-2 text-center text-font14 font-bold text-neutral-500">
          Para recusar esse pedido super expresso, informe o motivo de recusa
        </p>
        <div className="flex flex-col gap-2">
          <p className="text-font12 text-neutral-500">Selecione o motivo</p>
          <Select.Wrapper
            name="reason"
            onChange={handleChange}
            options={refuseReasonsOptions}
            status={errors.reason ? 'error' : undefined}
          >
            <Select.Input placeholder="Selecione..." />
            <Select.StatusArrow />
          </Select.Wrapper>
        </div>
      </div>
      <div className="flex gap-4 py-6">
        <Button full variant="secondary" type="button" onClick={onBack}>
          Voltar
        </Button>
        <Button
          full
          type="button"
          onClick={() => onRefuse(values.reason)}
          variant="danger"
          disabled={!values.reason}
        >
          Recusar
        </Button>
      </div>
    </>
  );
}
